import React from "react";
import "./StaticPages.css";
import Seo from "./Common/Seo";

const privacyItems = [
  { id: "candidate-data", title: "Candidate Data", text: "Epic-Jobs stores candidate account details, profile information, saved jobs, alerts, resumes, and job applications so candidates can search and apply for opportunities." },
  { id: "employer-data", title: "Employer Data", text: "Employer company profiles, job posts, applicant records, posting credits, plans, and invoice information are used to support hiring workflows and platform administration." },
  { id: "uploads", title: "Uploads And Files", text: "Company logos, cover images, candidate photos, resumes, and application resumes may be stored in public or protected storage paths depending on their purpose in the platform." },
  { id: "admin-access", title: "Admin Access", text: "Authorized admins may review users, jobs, applications, contact messages, payments, upload diagnostics, and audit history to support security, quality, and customer service." },
  { id: "payments", title: "Payment Data", text: "When payment processing is enabled, transaction and billing data may be handled by Stripe or another approved payment provider. Epic-Jobs should not store full card numbers." },
  { id: "contact", title: "Contact And Support", text: "Messages submitted through the contact form are stored for admin review. For privacy questions, contact 832.795.3431 or Support@Epic-Jobs.com." },
];

const Privacy = () => {
  return (
    <section className="static-page-section">
      <Seo title="Privacy Center | Epic-Jobs" description="Learn how Epic-Jobs handles account data, candidate profiles, resumes, job applications, uploads, messages, and payment records." />
      <div className="auto-container">
        <div className="static-hero">
          <h1>Privacy Center</h1>
          <p>How Epic-Jobs handles account, profile, job, application, upload, support, and payment-related information.</p>
        </div>
        <div className="row">
          {privacyItems.map((item) => (
            <div className="col-lg-6 col-md-12" key={item.id}>
              <div className="ls-widget">
                <div className="widget-title"><h4>{item.title}</h4></div>
                <div className="widget-content"><p>{item.text}</p></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Privacy;
